import { createStore, type StoreApi } from 'zustand';

export type VehicleAssignmentState = {
    selectedAssignmentId: string | null;
    isOpen: boolean;
};

export type VehicleAssignmentActions = {
    openDrawer: (id: string) => void;
    resetStore: () => void;
};

export type VehicleAssignmentStore = VehicleAssignmentState & VehicleAssignmentActions;

export const initialState: VehicleAssignmentState = {
    selectedAssignmentId: null,
    isOpen: false,
};

export function createVehicleAssignmentStore(vehicleAssignmentState: VehicleAssignmentState = initialState): StoreApi<VehicleAssignmentStore> {
    return createStore<VehicleAssignmentStore>()((set) => ({
        ...vehicleAssignmentState,
        openDrawer: (id): void => {
            set(() => ({
                selectedAssignmentId: id,
                isOpen: true,
            }));
        },
        resetStore: (): void => {
            set(initialState);
        },
    }));
}
